"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reason = exports.ExitType = void 0;
var ExitType;
(function (ExitType) {
    ExitType["Account"] = "account";
    ExitType["Subscription"] = "subscription";
})(ExitType = exports.ExitType || (exports.ExitType = {}));
var Reason;
(function (Reason) {
    Reason["None"] = "none";
    Reason["Content"] = "content";
    Reason["Time"] = "time";
    Reason["ManualPayment"] = "manualPayment";
    Reason["Cost"] = "cost";
    Reason["Other"] = "other";
})(Reason = exports.Reason || (exports.Reason = {}));
//# sourceMappingURL=ExitReason.js.map